import { render, staticRenderFns } from "./LegendComponent.vue?vue&type=template&id=6aa854fd&"
import script from "./LegendComponent.vue?vue&type=script&lang=js&"
export * from "./LegendComponent.vue?vue&type=script&lang=js&"
import style0 from "./LegendComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports